import React from "react";

export const Book = (props) => {
  return (
    <div id="book">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 text-center">
            <div className="section-title">
              <h2>DAS KINDERBUCH</h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 text-center">
            <div className="video-container">
              <video controls width="768" height="576">
                <source src="img/book/slideshow.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
